import { render, staticRenderFns } from "./role-inspector-list.vue?vue&type=template&id=3a3f9222&scoped=true"
import script from "./role-inspector-list.vue?vue&type=script&lang=js"
export * from "./role-inspector-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f9222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3f9222')) {
      api.createRecord('3a3f9222', component.options)
    } else {
      api.reload('3a3f9222', component.options)
    }
    module.hot.accept("./role-inspector-list.vue?vue&type=template&id=3a3f9222&scoped=true", function () {
      api.rerender('3a3f9222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/project-management/role-inspector-list.vue"
export default component.exports